import { render, staticRenderFns } from "./FormContenedorEditar.vue?vue&type=template&id=d445f44c"
import script from "./FormContenedorEditar.vue?vue&type=script&lang=js"
export * from "./FormContenedorEditar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports